export const readingCalendarEn = {
  title: 'Reading calendar',
  yearTitle: 'Your reading year',
  yearHint: 'A little reading, a lasting story.',
  previousYear: 'Previous year',
  nextYear: 'Next year',
  previousMonth: 'Previous month',
  nextMonth: 'Next month',
  backToYear: 'Year overview',
  monthAccessibility: '{{month}}: {{books}} books finished, {{pages}} pages recorded',
  booksFinished_one: '{{count}} book finished',
  booksFinished_other: '{{count}} books finished',
  booksFinished_few: '{{count}} books finished',
  booksFinished_many: '{{count}} books finished',
  pagesRecorded: '{{count}} pages recorded',
  pagesShort: '{{count}} pages',
  goalPages: '{{count}} pages since {{date}}',
  pagesRecorded_one: '{{count}} page recorded',
  pagesRecorded_few: '{{count}} pages recorded',
  pagesRecorded_many: '{{count}} pages recorded',
  pagesRecorded_other: '{{count}} pages recorded',
  pagesShort_one: '{{count}} page',
  pagesShort_few: '{{count}} pages',
  pagesShort_many: '{{count}} pages',
  pagesShort_other: '{{count}} pages',
  goalPages_one: '{{count}} page since {{date}}',
  goalPages_few: '{{count}} pages since {{date}}',
  goalPages_many: '{{count}} pages since {{date}}',
  goalPages_other: '{{count}} pages since {{date}}',
  updatePages_one: '+{{count}} page',
  updatePages_few: '+{{count}} pages',
  updatePages_many: '+{{count}} pages',
  updatePages_other: '+{{count}} pages',
  overflow: '+{{count}}',
  future: 'Still to come',
  emptyMonth: 'Room for a story',
  undatedTitle: 'Finished, date unknown',
  undatedBody: 'These books stay in your history without being placed in a month.',
  monthFinished: 'Finished this month',
  noFinished: 'No books finished this month yet.',
  activityLegend: 'Reading recorded',
  partialLegend: 'Some pages',
  completeLegend: 'Daily pace reached',
  preGoalLegend: 'Before your goal',
  neutralHint: 'A quiet day means no reading was recorded.',
  dayAccessibility: '{{date}}: {{pages}} pages recorded, {{books}} books finished. {{status}}',
  dailyPace: '{{current}} of {{target}} pages',
  dayTitle: '{{date}}',
  dayEmpty: 'No page updates recorded for this day.',
  dayFinished: 'Finished this day',
  updatePages: '+{{count}} pages',
  updateRange: 'Page {{from}} → {{to}}',
  dayBooks_one: 'Across {{count}} book',
  dayBooks_other: 'Across {{count}} books',
  dayBooks_few: 'Across {{count}} books',
  dayBooks_many: 'Across {{count}} books',
  noGoal: 'Your reading history is here, with or without a goal.',
  addGoal: 'Set a reading goal',
  loading: 'Gathering your reading history…',
  loadFailed: 'Your reading history could not be loaded.',
  historyUnavailable: 'Calendar history needs a newer version of the reading service.',
  finishedOn: 'Finished {{date}}',
  openBook: 'Open {{title}}',
  close: 'Close day details',
  missingCover: 'No cover available',
};

export const readingCalendarSk: typeof readingCalendarEn = {
  title: 'Kalendár čítania',
  yearTitle: 'Tvoj čitateľský rok',
  yearHint: 'Trochu čítania, trvalý príbeh.',
  previousYear: 'Predchádzajúci rok',
  nextYear: 'Nasledujúci rok',
  previousMonth: 'Predchádzajúci mesiac',
  nextMonth: 'Nasledujúci mesiac',
  backToYear: 'Prehľad roka',
  monthAccessibility: '{{month}}: dočítané knihy {{books}}, zaznamenané strany {{pages}}',
  booksFinished_one: '{{count}} dočítaná kniha',
  booksFinished_other: '{{count}} dočítaných kníh',
  booksFinished_few: '{{count}} dočítané knihy',
  booksFinished_many: '{{count}} dočítanej knihy',
  pagesRecorded: '{{count}} zaznamenaných strán',
  pagesShort: '{{count}} strán',
  goalPages: '{{count}} strán od {{date}}',
  pagesRecorded_one: '{{count}} zaznamenaná strana',
  pagesRecorded_few: '{{count}} zaznamenané strany',
  pagesRecorded_many: '{{count}} zaznamenanej strany',
  pagesRecorded_other: '{{count}} zaznamenaných strán',
  pagesShort_one: '{{count}} strana',
  pagesShort_few: '{{count}} strany',
  pagesShort_many: '{{count}} strany',
  pagesShort_other: '{{count}} strán',
  goalPages_one: '{{count}} strana od {{date}}',
  goalPages_few: '{{count}} strany od {{date}}',
  goalPages_many: '{{count}} strany od {{date}}',
  goalPages_other: '{{count}} strán od {{date}}',
  updatePages_one: '+{{count}} strana',
  updatePages_few: '+{{count}} strany',
  updatePages_many: '+{{count}} strany',
  updatePages_other: '+{{count}} strán',
  overflow: '+{{count}}',
  future: 'Ešte len príde',
  emptyMonth: 'Miesto na príbeh',
  undatedTitle: 'Dočítané bez dátumu',
  undatedBody: 'Tieto knihy ostávajú v tvojej histórii bez priradenia k mesiacu.',
  monthFinished: 'Dočítané tento mesiac',
  noFinished: 'Tento mesiac zatiaľ nemáš dočítanú knihu.',
  activityLegend: 'Zaznamenané čítanie',
  partialLegend: 'Prečítané strany',
  completeLegend: 'Denné tempo dosiahnuté',
  preGoalLegend: 'Pred začiatkom cieľa',
  neutralHint: 'Pokojný deň znamená, že nebolo zaznamenané čítanie.',
  dayAccessibility: '{{date}}: zaznamenané strany {{pages}}, dočítané knihy {{books}}. {{status}}',
  dailyPace: '{{current}} z {{target}} strán',
  dayTitle: '{{date}}',
  dayEmpty: 'Na tento deň nie sú zaznamenané žiadne aktualizácie strán.',
  dayFinished: 'Dočítané v tento deň',
  updatePages: '+{{count}} strán',
  updateRange: 'Strana {{from}} → {{to}}',
  dayBooks_one: 'V {{count}} knihe',
  dayBooks_other: 'V {{count}} knihách',
  dayBooks_few: 'V {{count}} knihách',
  dayBooks_many: 'V {{count}} knihy',
  noGoal: 'Tvoja história čítania je tu s cieľom aj bez neho.',
  addGoal: 'Nastaviť čitateľský cieľ',
  loading: 'Načítava sa história čítania…',
  loadFailed: 'Históriu čítania sa nepodarilo načítať.',
  historyUnavailable: 'Kalendár čítania vyžaduje novšiu verziu služby.',
  finishedOn: 'Dočítané {{date}}',
  openBook: 'Otvoriť {{title}}',
  close: 'Zavrieť podrobnosti dňa',
  missingCover: 'Obálka nie je dostupná',
};

export const readingCalendarCs: typeof readingCalendarEn = {
  title: 'Kalendář čtení',
  yearTitle: 'Tvůj čtenářský rok',
  yearHint: 'Trochu čtení, trvalý příběh.',
  previousYear: 'Předchozí rok',
  nextYear: 'Následující rok',
  previousMonth: 'Předchozí měsíc',
  nextMonth: 'Následující měsíc',
  backToYear: 'Přehled roku',
  monthAccessibility: '{{month}}: dočtené knihy {{books}}, zaznamenané stránky {{pages}}',
  booksFinished_one: '{{count}} dočtená kniha',
  booksFinished_other: '{{count}} dočtených knih',
  booksFinished_few: '{{count}} dočtené knihy',
  booksFinished_many: '{{count}} dočtené knihy',
  pagesRecorded: '{{count}} zaznamenaných stránek',
  pagesShort: '{{count}} stránek',
  goalPages: '{{count}} stránek od {{date}}',
  pagesRecorded_one: '{{count}} zaznamenaná stránka',
  pagesRecorded_few: '{{count}} zaznamenané stránky',
  pagesRecorded_many: '{{count}} zaznamenané stránky',
  pagesRecorded_other: '{{count}} zaznamenaných stránek',
  pagesShort_one: '{{count}} stránka',
  pagesShort_few: '{{count}} stránky',
  pagesShort_many: '{{count}} stránky',
  pagesShort_other: '{{count}} stránek',
  goalPages_one: '{{count}} stránka od {{date}}',
  goalPages_few: '{{count}} stránky od {{date}}',
  goalPages_many: '{{count}} stránky od {{date}}',
  goalPages_other: '{{count}} stránek od {{date}}',
  updatePages_one: '+{{count}} stránka',
  updatePages_few: '+{{count}} stránky',
  updatePages_many: '+{{count}} stránky',
  updatePages_other: '+{{count}} stránek',
  overflow: '+{{count}}',
  future: 'Teprve přijde',
  emptyMonth: 'Místo na příběh',
  undatedTitle: 'Dočtené bez data',
  undatedBody: 'Tyto knihy zůstávají ve tvé historii bez přiřazení k měsíci.',
  monthFinished: 'Dočtené tento měsíc',
  noFinished: 'Tento měsíc zatím nemáš dočtenou knihu.',
  activityLegend: 'Zaznamenané čtení',
  partialLegend: 'Přečtené stránky',
  completeLegend: 'Denní tempo dosaženo',
  preGoalLegend: 'Před začátkem cíle',
  neutralHint: 'Klidný den znamená, že nebylo zaznamenáno čtení.',
  dayAccessibility: '{{date}}: zaznamenané stránky {{pages}}, dočtené knihy {{books}}. {{status}}',
  dailyPace: '{{current}} z {{target}} stránek',
  dayTitle: '{{date}}',
  dayEmpty: 'Pro tento den nejsou zaznamenány žádné aktualizace stránek.',
  dayFinished: 'Dočtené v tento den',
  updatePages: '+{{count}} stránek',
  updateRange: 'Strana {{from}} → {{to}}',
  dayBooks_one: 'V {{count}} knize',
  dayBooks_other: 'V {{count}} knihách',
  dayBooks_few: 'V {{count}} knihách',
  dayBooks_many: 'V {{count}} knihy',
  noGoal: 'Tvá historie čtení je tu s cílem i bez něj.',
  addGoal: 'Nastavit čtenářský cíl',
  loading: 'Načítá se historie čtení…',
  loadFailed: 'Historii čtení se nepodařilo načíst.',
  historyUnavailable: 'Kalendář čtení vyžaduje novější verzi služby.',
  finishedOn: 'Dočteno {{date}}',
  openBook: 'Otevřít {{title}}',
  close: 'Zavřít podrobnosti dne',
  missingCover: 'Obálka není dostupná',
};
